import * as React from 'react';
import dynamic from 'next/dynamic';
const ReactPlayer = dynamic(() => import('react-player/lazy'), { ssr: false });
import useResizeObserver from '@react-hook/resize-observer';
import ImageCredits from '@components/image-credits/imageCredits';
import Image from 'next/image';

interface VideoProps {
  backgroundVideo?: any;
  videoCopyright?: any;
  page?: any;
}

const VideoWrapper = ({ children, parentHeight, parentWidth }: any) => {
  const [height, setHeight] = React.useState('auto'),
    [width, setWidth] = React.useState('100%'),
    [paddingTop, setPaddingTop] = React.useState('56.25%'),
    ratio = 0.5625;

  React.useEffect(() => {
    if (parentHeight / parentWidth < ratio) {
      setHeight('auto');
      setWidth('100%');
      setPaddingTop('56.25%');
    } else {
      setHeight('100%');
      setWidth(`${parentHeight / ratio}px`);
      setPaddingTop('0');
    }
  }, [parentHeight, parentWidth]);

  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width,
        height,
        paddingTop,
      }}
    >
      {children}
    </div>
  );
};

const VideoArea = ({ page, backgroundVideo, videoCopyright }: VideoProps) => {
  const [height, setHeight] = React.useState(0),
    [width, setWidth] = React.useState(0),
    heroRef = React.useRef<HTMLDivElement>(null);

  const [thumbnailOpacity, setThumbnailOpacity] = React.useState(1);
  const [playVideo, setPlayVideo] = React.useState(false);

  const handleReady = () => {
    setPlayVideo(true);
    const fadeOutTimeout = setTimeout(() => {
      setThumbnailOpacity(0);
    }, 1000);

    return () => {
      clearTimeout(fadeOutTimeout);
    };
  };

  const handleStart = () => {
    setThumbnailOpacity(0);
  };

  useResizeObserver(heroRef, (entry) => {
    if (entry.contentRect) {
      setHeight(entry.contentRect.height);
      setWidth(entry.contentRect.width);
    }
  });

  return (
    <div
      style={{
        height: page != 'homepage' ? '285px' : '550px',
        position: 'relative',
        overflow: 'hidden',
      }}
      ref={heroRef}
    >
      {videoCopyright ? (
        <ImageCredits copyright={videoCopyright} position="overlay-top" />
      ) : (
        ''
      )}
      <VideoWrapper parentHeight={height} parentWidth={width}>
        <div
          style={{
            position: 'absolute',
            opacity: thumbnailOpacity,
            transition: 'opacity 1.5s ease-in-out',
            top: page != 'homepage' ? '0' : '-25%',
            width: '100%',
            height: page != 'homepage' ? '100%' : '150%',
            zIndex: 1,
          }}
        >
          <Image
            style={{
              width: '100%',
              height: '100%',
            }}
            alt=""
            src={backgroundVideo.thumbnail_url}
            width={backgroundVideo.thumbnail_width}
            height={backgroundVideo.thumbnail_height}
          />
        </div>
        <ReactPlayer
          className="wwi-hero-video"
          url={backgroundVideo.embed_url}
          width="100%"
          height="100%"
          style={{
            position: 'absolute',
            top: 0
          }}
          playing={playVideo}
          onReady={handleReady}
          onStart={handleStart}
          volume={0}
          loop={true}
          muted={true}
          config={{
            youtube: {
              playerVars: {
                ignoreTracking: 1,
              },
            },
          }}
        />
      </VideoWrapper>
    </div>
  );
};

export default VideoArea;
